<template>
  <div class="row">
    <div class="col">
      <AppInput
        type="text"
        full-width
        :input-value="localValue"
        :is-readonly="viewMode"
        :is-disabled="viewMode"
        :error-msg="customValidation ? $t('surveyQuestionScreen.openAnswerOption.errorMsgValidation') : $t('surveyQuestionScreen.openAnswerOption.errorMsgText')"
        :is-invalid="isInvalid"
        @blur="answered"
        @change="valueChange"
      />
    </div>
  </div>
</template>

<script>
import AppInput from "../../AppInput.vue";

export default {
  'name': 'OpenAnswerBoxOption',
  components: { AppInput },
  'props': {
    'answerName': '',
    'viewMode': {
      'type': Boolean,
      'required': false
    },
    'customValidation': {
      type: String,
      required: false,
    }
  },
  data() {
    return {
      'localValue': '',
      'isInvalid': false,
    }
  },
  'watch': {
    answerName(newValue) {
      this.localValue = newValue;
    }
  },
  'methods': {
    valueChange(e) {
      this.localValue = e.target.value
    },
    answered() {
      if (this.customValidation) {
        const regex = new RegExp(this.customValidation, 'g');
        this.isInvalid = !regex.test(this.localValue);
        this.$emit('onAnswered', this.isInvalid ? null : this.localValue);
      } else {
        if (this.localValue !== '') {
          this.$emit('onAnswered', this.localValue)
        } else {
          this.$emit('onAnswered', null);
        }
      }
    }
  },
  created() {
    this.localValue = this.answerName ? this.answerName : null
  }
}
</script>

<style scoped>

</style>
